export enum ServiceLevelCode {
  BKTR = 'BKTR',
  NUGP = 'NUGP',
  NURG = 'NURG',
  PRPT = 'PRPT',
  SDVA = 'SDVA',
  SEPA = 'SEPA',
  URGP = 'URGP',
  URNS = 'URNS',
  EAPS = 'EAPS',
  EOLO = 'EOLO',
  G001 = 'G001',
  G002 = 'G002',
  G003 = 'G003',
  G004 = 'G004',
  G005 = 'G005',
  G006 = 'G006',
  G007 = 'G007',
  G009 = 'G009',
  INST = 'INST',
  IRCA = 'IRCA',
  NPCA = 'NPCA',
  SPLI = 'SPLI',
  SPSC = 'SPSC',
  SRTP = 'SRTP',
  SVAT = 'SVAT',
  SVDE = 'SVDE',
  WFSM = 'WFSM',
}
